module.exports = __webpack_public_path__ + "videos/gradient-map_cn.a817a75.mp4";